/*! Magnific Popup - v1.1.0 - 2016-02-20
* http://dimsemenov.com/plugins/magnific-popup/
* Copyright (c) 2016 Dmitry Semenov; */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):a("object"==typeof exports?require("jquery"):window.jQuery||window.Zepto)}(function(a){var b,c,d,e,f,g,h="Close",i="BeforeClose",j="AfterClose",k="BeforeAppend",l="MarkupParse",m="Open",n="Change",o="mfp",p="."+o,q="mfp-ready",r="mfp-removing",s="mfp-prevent-close",t=function(){},u=!!window.jQuery,v=a(window),w=function(a,c){b.ev.on(o+a+p,c)},x=function(b,c,d,e){var f=document.createElement("div");return f.className="mfp-"+b,d&&(f.innerHTML=d),e?c&&c.appendChild(f):(f=a(f),c&&f.appendTo(c)),f},y=function(c,d){b.ev.triggerHandler(o+c,d),b.st.callbacks&&(c=c.charAt(0).toLowerCase()+c.slice(1),b.st.callbacks[c]&&b.st.callbacks[c].apply(b,a.isArray(d)?d:[d]))},z=function(c){return c===g&&b.currTemplate.closeBtn||(b.currTemplate.closeBtn=a(b.st.closeMarkup.replace("%title%",b.st.tClose)),g=c),b.currTemplate.closeBtn},A=function(){a.magnificPopup.instance||(b=new t,b.init(),a.magnificPopup.instance=b)},B=function(){var a=document.createElement("p").style,b=["ms","O","Moz","Webkit"];if(void 0!==a.transition)return!0;for(;b.length;)if(b.pop()+"Transition"in a)return!0;return!1};t.prototype={constructor:t,init:function(){var c=navigator.appVersion;b.isLowIE=b.isIE8=document.all&&!document.addEventListener,b.isAndroid=/android/gi.test(c),b.isIOS=/iphone|ipad|ipod/gi.test(c),b.supportsTransition=B(),b.probablyMobile=b.isAndroid||b.isIOS||/(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent),d=a(document),b.popupsCache={}},open:function(c){var e;if(c.isObj===!1){b.items=c.items.toArray(),b.index=0;var g,h=c.items;for(e=0;e<h.length;e++)if(g=h[e],g.parsed&&(g=g.el[0]),g===c.el[0]){b.index=e;break}}else b.items=a.isArray(c.items)?c.items:[c.items],b.index=c.index||0;if(b.isOpen)return void b.updateItemHTML();b.types=[],f="",c.mainEl&&c.mainEl.length?b.ev=c.mainEl.eq(0):b.ev=d,c.key?(b.popupsCache[c.key]||(b.popupsCache[c.key]={}),b.currTemplate=b.popupsCache[c.key]):b.currTemplate={},b.st=a.extend(!0,{},a.magnificPopup.defaults,c),b.fixedContentPos="auto"===b.st.fixedContentPos?!b.probablyMobile:b.st.fixedContentPos,b.st.modal&&(b.st.closeOnContentClick=!1,b.st.closeOnBgClick=!1,b.st.showCloseBtn=!1,b.st.enableEscapeKey=!1),b.bgOverlay||(b.bgOverlay=x("bg").on("click"+p,function(){b.close()}),b.wrap=x("wrap").attr("tabindex",-1).on("click"+p,function(a){b._checkIfClose(a.target)&&b.close()}),b.container=x("container",b.wrap)),b.contentContainer=x("content"),b.st.preloader&&(b.preloader=x("preloader",b.container,b.st.tLoading));var i=a.magnificPopup.modules;for(e=0;e<i.length;e++){var j=i[e];j=j.charAt(0).toUpperCase()+j.slice(1),b["init"+j].call(b)}y("BeforeOpen"),b.st.showCloseBtn&&(b.st.closeBtnInside?(w(l,function(a,b,c,d){c.close_replaceWith=z(d.type)}),f+=" mfp-close-btn-in"):b.wrap.append(z())),b.st.alignTop&&(f+=" mfp-align-top"),b.fixedContentPos?b.wrap.css({overflow:b.st.overflowY,overflowX:"hidden",overflowY:b.st.overflowY}):b.wrap.css({top:v.scrollTop(),position:"absolute"}),(b.st.fixedBgPos===!1||"auto"===b.st.fixedBgPos&&!b.fixedContentPos)&&b.bgOverlay.css({height:d.height(),position:"absolute"}),b.st.enableEscapeKey&&d.on("keyup"+p,function(a){27===a.keyCode&&b.close()}),v.on("resize"+p,function(){b.updateSize()}),b.st.closeOnContentClick||(f+=" mfp-auto-cursor"),f&&b.wrap.addClass(f);var k=b.wH=v.height(),n={};if(b.fixedContentPos&&b._hasScrollBar(k)){var o=b._getScrollbarSize();o&&(n.marginRight=o)}b.fixedContentPos&&(b.isIE7?a("body, html").css("overflow","hidden"):n.overflow="hidden");var r=b.st.mainClass;return b.isIE7&&(r+=" mfp-ie7"),r&&b._addClassToMFP(r),b.updateItemHTML(),y("BuildControls"),a("html").css(n),b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo||a(document.body)),b._lastFocusedEl=document.activeElement,setTimeout(function(){b.content?(b._addClassToMFP(q),b._setFocus()):b.bgOverlay.addClass(q),d.on("focusin"+p,b._onFocusIn)},16),b.isOpen=!0,b.updateSize(k),y(m),c},close:function(){b.isOpen&&(y(i),b.isOpen=!1,b.st.removalDelay&&!b.isLowIE&&b.supportsTransition?(b._addClassToMFP(r),setTimeout(function(){b._close()},b.st.removalDelay)):b._close())},_close:function(){y(h);var c=r+" "+q+" ";if(b.bgOverlay.detach(),b.wrap.detach(),b.container.empty(),b.st.mainClass&&(c+=b.st.mainClass+" "),b._removeClassFromMFP(c),b.fixedContentPos){var e={marginRight:""};b.isIE7?a("body, html").css("overflow",""):e.overflow="",a("html").css(e)}d.off("keyup"+p+" focusin"+p),b.ev.off(p),b.wrap.attr("class","mfp-wrap").removeAttr("style"),b.bgOverlay.attr("class","mfp-bg"),b.container.attr("class","mfp-container"),!b.st.showCloseBtn||b.st.closeBtnInside&&b.currTemplate[b.currItem.type]!==!0||b.currTemplate.closeBtn&&b.currTemplate.closeBtn.detach(),b.st.autoFocusLast&&b._lastFocusedEl&&a(b._lastFocusedEl).focus(),b.currItem=null,b.content=null,b.currTemplate=null,b.prevHeight=0,y(j)},updateSize:function(a){if(b.isIOS){var c=document.documentElement.clientWidth/window.innerWidth,d=window.innerHeight*c;b.wrap.css("height",d),b.wH=d}else b.wH=a||v.height();b.fixedContentPos||b.wrap.css("height",b.wH),y("Resize")},updateItemHTML:function(){var c=b.items[b.index];b.contentContainer.detach(),b.content&&b.content.detach(),c.parsed||(c=b.parseEl(b.index));var d=c.type;if(y("BeforeChange",[b.currItem?b.currItem.type:"",d]),b.currItem=c,!b.currTemplate[d]){var f=b.st[d]?b.st[d].markup:!1;y("FirstMarkupParse",f),f?b.currTemplate[d]=a(f):b.currTemplate[d]=!0}e&&e!==c.type&&b.container.removeClass("mfp-"+e+"-holder");var g=b["get"+d.charAt(0).toUpperCase()+d.slice(1)](c,b.currTemplate[d]);b.appendContent(g,d),c.preloaded=!0,y(n,c),e=c.type,b.container.prepend(b.contentContainer),y("AfterChange")},appendContent:function(a,c){b.content=a,a?b.st.showCloseBtn&&b.st.closeBtnInside&&b.currTemplate[c]===!0?b.content.find(".mfp-close").length||b.content.append(z()):b.content=a:b.content="",y(k),b.container.addClass("mfp-"+c+"-holder"),b.contentContainer.append(b.content)},parseEl:function(c){var d,e=b.items[c];if(e.tagName?e={el:a(e)}:(d=e.type,e={data:e,src:e.src}),e.el){for(var f=b.types,g=0;g<f.length;g++)if(e.el.hasClass("mfp-"+f[g])){d=f[g];break}e.src=e.el.attr("data-mfp-src"),e.src||(e.src=e.el.attr("href"))}return e.type=d||b.st.type||"inline",e.index=c,e.parsed=!0,b.items[c]=e,y("ElementParse",e),b.items[c]},addGroup:function(a,c){var d=function(d){d.mfpEl=this,b._openClick(d,a,c)};c||(c={});var e="click.magnificPopup";c.mainEl=a,c.items?(c.isObj=!0,a.off(e).on(e,d)):(c.isObj=!1,c.delegate?a.off(e).on(e,c.delegate,d):(c.items=a,a.off(e).on(e,d)))},_openClick:function(c,d,e){var f=void 0!==e.midClick?e.midClick:a.magnificPopup.defaults.midClick;if(f||!(2===c.which||c.ctrlKey||c.metaKey||c.altKey||c.shiftKey)){var g=void 0!==e.disableOn?e.disableOn:a.magnificPopup.defaults.disableOn;if(g)if(a.isFunction(g)){if(!g.call(b))return!0}else if(v.width()<g)return!0;c.type&&(c.preventDefault(),b.isOpen&&c.stopPropagation()),e.el=a(c.mfpEl),e.delegate&&(e.items=d.find(e.delegate)),b.open(e)}},updateStatus:function(a,d){if(b.preloader){c!==a&&b.container.removeClass("mfp-s-"+c),d||"loading"!==a||(d=b.st.tLoading);var e={status:a,text:d};y("UpdateStatus",e),a=e.status,d=e.text,b.preloader.html(d),b.preloader.find("a").on("click",function(a){a.stopImmediatePropagation()}),b.container.addClass("mfp-s-"+a),c=a}},_checkIfClose:function(c){if(!a(c).hasClass(s)){var d=b.st.closeOnContentClick,e=b.st.closeOnBgClick;if(d&&e)return!0;if(!b.content||a(c).hasClass("mfp-close")||b.preloader&&c===b.preloader[0])return!0;if(c===b.content[0]||a.contains(b.content[0],c)){if(d)return!0}else if(e&&a.contains(document,c))return!0;return!1}},_addClassToMFP:function(a){b.bgOverlay.addClass(a),b.wrap.addClass(a)},_removeClassFromMFP:function(a){this.bgOverlay.removeClass(a),b.wrap.removeClass(a)},_hasScrollBar:function(a){return(b.isIE7?d.height():document.body.scrollHeight)>(a||v.height())},_setFocus:function(){(b.st.focus?b.content.find(b.st.focus).eq(0):b.wrap).focus()},_onFocusIn:function(c){return c.target===b.wrap[0]||a.contains(b.wrap[0],c.target)?void 0:(b._setFocus(),!1)},_parseMarkup:function(b,c,d){var e;d.data&&(c=a.extend(d.data,c)),y(l,[b,c,d]),a.each(c,function(c,d){if(void 0===d||d===!1)return!0;if(e=c.split("_"),e.length>1){var f=b.find(p+"-"+e[0]);if(f.length>0){var g=e[1];"replaceWith"===g?f[0]!==d[0]&&f.replaceWith(d):"img"===g?f.is("img")?f.attr("src",d):f.replaceWith(a("<img>").attr("src",d).attr("class",f.attr("class"))):f.attr(e[1],d)}}else b.find(p+"-"+c).html(d)})},_getScrollbarSize:function(){if(void 0===b.scrollbarSize){var a=document.createElement("div");a.style.cssText="width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;",document.body.appendChild(a),b.scrollbarSize=a.offsetWidth-a.clientWidth,document.body.removeChild(a)}return b.scrollbarSize}},a.magnificPopup={instance:null,proto:t.prototype,modules:[],open:function(b,c){return A(),b=b?a.extend(!0,{},b):{},b.isObj=!0,b.index=c||0,this.instance.open(b)},close:function(){return a.magnificPopup.instance&&a.magnificPopup.instance.close()},registerModule:function(b,c){c.options&&(a.magnificPopup.defaults[b]=c.options),a.extend(this.proto,c.proto),this.modules.push(b)},defaults:{disableOn:0,key:null,midClick:!1,mainClass:"",preloader:!0,focus:"",closeOnContentClick:!1,closeOnBgClick:!0,closeBtnInside:!0,showCloseBtn:!0,enableEscapeKey:!0,modal:!1,alignTop:!1,removalDelay:0,prependTo:null,fixedContentPos:"auto",fixedBgPos:"auto",overflowY:"auto",closeMarkup:'<button title="%title%" type="button" class="mfp-close">&#215;</button>',tClose:"Close (Esc)",tLoading:"Loading...",autoFocusLast:!0}},a.fn.magnificPopup=function(c){A();var d=a(this);if("string"==typeof c)if("open"===c){var e,f=u?d.data("magnificPopup"):d[0].magnificPopup,g=parseInt(arguments[1],10)||0;f.items?e=f.items[g]:(e=d,f.delegate&&(e=e.find(f.delegate)),e=e.eq(g)),b._openClick({mfpEl:e},d,f)}else b.isOpen&&b[c].apply(b,Array.prototype.slice.call(arguments,1));else c=a.extend(!0,{},c),u?d.data("magnificPopup",c):d[0].magnificPopup=c,b.addGroup(d,c);return d};var C,D,E,F="inline",G=function(){E&&(D.after(E.addClass(C)).detach(),E=null)};a.magnificPopup.registerModule(F,{options:{hiddenClass:"hide",markup:"",tNotFound:"Content not found"},proto:{initInline:function(){b.types.push(F),w(h+"."+F,function(){G()})},getInline:function(c,d){if(G(),c.src){var e=b.st.inline,f=a(c.src);if(f.length){var g=f[0].parentNode;g&&g.tagName&&(D||(C=e.hiddenClass,D=x(C),C="mfp-"+C),E=f.after(D).detach().removeClass(C)),b.updateStatus("ready")}else b.updateStatus("error",e.tNotFound),f=a("<div>");return c.inlineElement=f,f}return b.updateStatus("ready"),b._parseMarkup(d,{},c),d}}});var H,I="ajax",J=function(){H&&a(document.body).removeClass(H)},K=function(){J(),b.req&&b.req.abort()};a.magnificPopup.registerModule(I,{options:{settings:null,cursor:"mfp-ajax-cur",tError:'<a href="%url%">The content</a> could not be loaded.'},proto:{initAjax:function(){b.types.push(I),H=b.st.ajax.cursor,w(h+"."+I,K),w("BeforeChange."+I,K)},getAjax:function(c){H&&a(document.body).addClass(H),b.updateStatus("loading");var d=a.extend({url:c.src,success:function(d,e,f){var g={data:d,xhr:f};y("ParseAjax",g),b.appendContent(a(g.data),I),c.finished=!0,J(),b._setFocus(),setTimeout(function(){b.wrap.addClass(q)},16),b.updateStatus("ready"),y("AjaxContentAdded")},error:function(){J(),c.finished=c.loadError=!0,b.updateStatus("error",b.st.ajax.tError.replace("%url%",c.src))}},b.st.ajax.settings);return b.req=a.ajax(d),""}}});var L,M=function(c){if(c.data&&void 0!==c.data.title)return c.data.title;var d=b.st.image.titleSrc;if(d){if(a.isFunction(d))return d.call(b,c);if(c.el)return c.el.attr(d)||""}return""};a.magnificPopup.registerModule("image",{options:{markup:'<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',cursor:"mfp-zoom-out-cur",titleSrc:"title",verticalFit:!0,tError:'<a href="%url%">The image</a> could not be loaded.'},proto:{initImage:function(){var c=b.st.image,d=".image";b.types.push("image"),w(m+d,function(){"image"===b.currItem.type&&c.cursor&&a(document.body).addClass(c.cursor)}),w(h+d,function(){c.cursor&&a(document.body).removeClass(c.cursor),v.off("resize"+p)}),w("Resize"+d,b.resizeImage),b.isLowIE&&w("AfterChange",b.resizeImage)},resizeImage:function(){var a=b.currItem;if(a&&a.img&&b.st.image.verticalFit){var c=0;b.isLowIE&&(c=parseInt(a.img.css("padding-top"),10)+parseInt(a.img.css("padding-bottom"),10)),a.img.css("max-height",b.wH-c)}},_onImageHasSize:function(a){a.img&&(a.hasSize=!0,L&&clearInterval(L),a.isCheckingImgSize=!1,y("ImageHasSize",a),a.imgHidden&&(b.content&&b.content.removeClass("mfp-loading"),a.imgHidden=!1))},findImageSize:function(a){var c=0,d=a.img[0],e=function(f){L&&clearInterval(L),L=setInterval(function(){return d.naturalWidth>0?void b._onImageHasSize(a):(c>200&&clearInterval(L),c++,void(3===c?e(10):40===c?e(50):100===c&&e(500)))},f)};e(1)},getImage:function(c,d){var e=0,f=function(){c&&(c.img[0].complete?(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("ready")),c.hasSize=!0,c.loaded=!0,y("ImageLoadComplete")):(e++,200>e?setTimeout(f,100):g()))},g=function(){c&&(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("error",h.tError.replace("%url%",c.src))),c.hasSize=!0,c.loaded=!0,c.loadError=!0)},h=b.st.image,i=d.find(".mfp-img");if(i.length){var j=document.createElement("img");j.className="mfp-img",c.el&&c.el.find("img").length&&(j.alt=c.el.find("img").attr("alt")),c.img=a(j).on("load.mfploader",f).on("error.mfploader",g),j.src=c.src,i.is("img")&&(c.img=c.img.clone()),j=c.img[0],j.naturalWidth>0?c.hasSize=!0:j.width||(c.hasSize=!1)}return b._parseMarkup(d,{title:M(c),img_replaceWith:c.img},c),b.resizeImage(),c.hasSize?(L&&clearInterval(L),c.loadError?(d.addClass("mfp-loading"),b.updateStatus("error",h.tError.replace("%url%",c.src))):(d.removeClass("mfp-loading"),b.updateStatus("ready")),d):(b.updateStatus("loading"),c.loading=!0,c.hasSize||(c.imgHidden=!0,d.addClass("mfp-loading"),b.findImageSize(c)),d)}}});var N,O=function(){return void 0===N&&(N=void 0!==document.createElement("p").style.MozTransform),N};a.magnificPopup.registerModule("zoom",{options:{enabled:!1,easing:"ease-in-out",duration:300,opener:function(a){return a.is("img")?a:a.find("img")}},proto:{initZoom:function(){var a,c=b.st.zoom,d=".zoom";if(c.enabled&&b.supportsTransition){var e,f,g=c.duration,j=function(a){var b=a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),d="all "+c.duration/1e3+"s "+c.easing,e={position:"fixed",zIndex:9999,left:0,top:0,"-webkit-backface-visibility":"hidden"},f="transition";return e["-webkit-"+f]=e["-moz-"+f]=e["-o-"+f]=e[f]=d,b.css(e),b},k=function(){b.content.css("visibility","visible")};w("BuildControls"+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.content.css("visibility","hidden"),a=b._getItemToZoom(),!a)return void k();f=j(a),f.css(b._getOffset()),b.wrap.append(f),e=setTimeout(function(){f.css(b._getOffset(!0)),e=setTimeout(function(){k(),setTimeout(function(){f.remove(),a=f=null,y("ZoomAnimationEnded")},16)},g)},16)}}),w(i+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.st.removalDelay=g,!a){if(a=b._getItemToZoom(),!a)return;f=j(a)}f.css(b._getOffset(!0)),b.wrap.append(f),b.content.css("visibility","hidden"),setTimeout(function(){f.css(b._getOffset())},16)}}),w(h+d,function(){b._allowZoom()&&(k(),f&&f.remove(),a=null)})}},_allowZoom:function(){return"image"===b.currItem.type},_getItemToZoom:function(){return b.currItem.hasSize?b.currItem.img:!1},_getOffset:function(c){var d;d=c?b.currItem.img:b.st.zoom.opener(b.currItem.el||b.currItem);var e=d.offset(),f=parseInt(d.css("padding-top"),10),g=parseInt(d.css("padding-bottom"),10);e.top-=a(window).scrollTop()-f;var h={width:d.width(),height:(u?d.innerHeight():d[0].offsetHeight)-g-f};return O()?h["-moz-transform"]=h.transform="translate("+e.left+"px,"+e.top+"px)":(h.left=e.left,h.top=e.top),h}}});var P="iframe",Q="//about:blank",R=function(a){if(b.currTemplate[P]){var c=b.currTemplate[P].find("iframe");c.length&&(a||(c[0].src=Q),b.isIE8&&c.css("display",a?"block":"none"))}};a.magnificPopup.registerModule(P,{options:{markup:'<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',srcAction:"iframe_src",patterns:{youtube:{index:"youtube.com",id:"v=",src:"//www.youtube.com/embed/%id%?autoplay=1"},vimeo:{index:"vimeo.com/",id:"/",src:"//player.vimeo.com/video/%id%?autoplay=1"},gmaps:{index:"//maps.google.",src:"%id%&output=embed"}}},proto:{initIframe:function(){b.types.push(P),w("BeforeChange",function(a,b,c){b!==c&&(b===P?R():c===P&&R(!0))}),w(h+"."+P,function(){R()})},getIframe:function(c,d){var e=c.src,f=b.st.iframe;a.each(f.patterns,function(){return e.indexOf(this.index)>-1?(this.id&&(e="string"==typeof this.id?e.substr(e.lastIndexOf(this.id)+this.id.length,e.length):this.id.call(this,e)),e=this.src.replace("%id%",e),!1):void 0});var g={};return f.srcAction&&(g[f.srcAction]=e),b._parseMarkup(d,g,c),b.updateStatus("ready"),d}}});var S=function(a){var c=b.items.length;return a>c-1?a-c:0>a?c+a:a},T=function(a,b,c){return a.replace(/%curr%/gi,b+1).replace(/%total%/gi,c)};a.magnificPopup.registerModule("gallery",{options:{enabled:!1,arrowMarkup:'<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',preload:[0,2],navigateByImgClick:!0,arrows:!0,tPrev:"Previous (Left arrow key)",tNext:"Next (Right arrow key)",tCounter:"%curr% of %total%"},proto:{initGallery:function(){var c=b.st.gallery,e=".mfp-gallery";return b.direction=!0,c&&c.enabled?(f+=" mfp-gallery",w(m+e,function(){c.navigateByImgClick&&b.wrap.on("click"+e,".mfp-img",function(){return b.items.length>1?(b.next(),!1):void 0}),d.on("keydown"+e,function(a){37===a.keyCode?b.prev():39===a.keyCode&&b.next()})}),w("UpdateStatus"+e,function(a,c){c.text&&(c.text=T(c.text,b.currItem.index,b.items.length))}),w(l+e,function(a,d,e,f){var g=b.items.length;e.counter=g>1?T(c.tCounter,f.index,g):""}),w("BuildControls"+e,function(){if(b.items.length>1&&c.arrows&&!b.arrowLeft){var d=c.arrowMarkup,e=b.arrowLeft=a(d.replace(/%title%/gi,c.tPrev).replace(/%dir%/gi,"left")).addClass(s),f=b.arrowRight=a(d.replace(/%title%/gi,c.tNext).replace(/%dir%/gi,"right")).addClass(s);e.click(function(){b.prev()}),f.click(function(){b.next()}),b.container.append(e.add(f))}}),w(n+e,function(){b._preloadTimeout&&clearTimeout(b._preloadTimeout),b._preloadTimeout=setTimeout(function(){b.preloadNearbyImages(),b._preloadTimeout=null},16)}),void w(h+e,function(){d.off(e),b.wrap.off("click"+e),b.arrowRight=b.arrowLeft=null})):!1},next:function(){b.direction=!0,b.index=S(b.index+1),b.updateItemHTML()},prev:function(){b.direction=!1,b.index=S(b.index-1),b.updateItemHTML()},goTo:function(a){b.direction=a>=b.index,b.index=a,b.updateItemHTML()},preloadNearbyImages:function(){var a,c=b.st.gallery.preload,d=Math.min(c[0],b.items.length),e=Math.min(c[1],b.items.length);for(a=1;a<=(b.direction?e:d);a++)b._preloadItem(b.index+a);for(a=1;a<=(b.direction?d:e);a++)b._preloadItem(b.index-a)},_preloadItem:function(c){if(c=S(c),!b.items[c].preloaded){var d=b.items[c];d.parsed||(d=b.parseEl(c)),y("LazyLoad",d),"image"===d.type&&(d.img=a('<img class="mfp-img" />').on("load.mfploader",function(){d.hasSize=!0}).on("error.mfploader",function(){d.hasSize=!0,d.loadError=!0,y("LazyLoadError",d)}).attr("src",d.src)),d.preloaded=!0}}}});var U="retina";a.magnificPopup.registerModule(U,{options:{replaceSrc:function(a){return a.src.replace(/\.\w+$/,function(a){return"@2x"+a})},ratio:1},proto:{initRetina:function(){if(window.devicePixelRatio>1){var a=b.st.retina,c=a.ratio;c=isNaN(c)?c():c,c>1&&(w("ImageHasSize."+U,function(a,b){b.img.css({"max-width":b.img[0].naturalWidth/c,width:"100%"})}),w("ElementParse."+U,function(b,d){d.src=a.replaceSrc(d,c)}))}}}}),A()});


// Text Strokes
document.addEventListener("DOMContentLoaded", function() {

  //$('.product-block.product-description a').parent().remove();
  
  const applyTextShadow = (element) => {
    const color = "#000"; 
    const r = 4; 
    const n = Math.ceil(2 * Math.PI * r); 
    let str = '';

    for (let i = 0; i < n; i++) {
      
      const theta = 2 * Math.PI * i / n;
      str += (r * Math.cos(theta)) + "px " + (r * Math.sin(theta)) + "px 0 " + color + (i === n - 1 ? "" : ",");
    }
    element.style.textShadow = str;
  };

  document.querySelectorAll('.js-drawer-open-cart').forEach((item) => {
    item.addEventListener('click', function() {
    
    });
  });

  const sectionHeaderTitle = document.querySelectorAll(".section-header__title");
  const templatePageH3 = document.querySelectorAll(".template-page h3");
  const templatePageHeading = document.querySelectorAll(".headingoutline");
   const templateSectionHeading = document.querySelectorAll("h2.h2");
   const templateCountdown = document.querySelectorAll(".countdown__display-block h2");
  const videohero = document.querySelectorAll(".h1.hero__title .animation-contents");

  sectionHeaderTitle.forEach((element) => {
    applyTextShadow(element);
  });

  templatePageH3.forEach((element) => {
    applyTextShadow(element);
  });
   templatePageHeading.forEach((element) => {
    applyTextShadow(element);
  });
  templateSectionHeading.forEach((element) => {
    applyTextShadow(element);
  });
   templateCountdown.forEach((element) => {
    applyTextShadow(element);
  });
  videohero.forEach((element) => {
    applyTextShadow(element);
  });

  


  
});

$(document).ready(function() {
    // Function to observe class changes
    function observeClassChanges() {
        // Observe for class changes on .site-header__search-container
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.attributeName === "class") {
                    const target = $(mutation.target);
                    // Check if the .is-active class is now on the target
                    if (target.hasClass('is-active')) {
                        // Focus on the child input with the specific class
                        target.find('.site-header__search-input').focus();
                    }
                }
            });
        });

        // Target the node (div) to observe for mutations
        const targetNode = $('.site-header__search-container')[0];

        // Watch for when the class attribute changes
        observer.observe(targetNode, {
            attributes: true
        });
    }

    // Function to handle closing the search box
    function closeSearchBox() {
        $('.js-search-header-close').on('click', function() {
            // Remove .is-active class from the .site-header__search-container
            $('.site-header__search-container').removeClass('is-active');
        });
    }

    // Call the functions to activate them
    observeClassChanges();
    closeSearchBox();
});

// document.addEventListener('DOMContentLoaded', () => {
//   // Select the target node
//   var target = document.querySelector('body');

//   // Create an observer instance
//   var observer = new MutationObserver((mutations) => {
//     mutations.forEach((mutation) => {
//       if (!mutation.addedNodes) return;

//       for (var i = 0; i < mutation.addedNodes.length; i++) {
//         // Check if the added node is our modal container
//         var node = mutation.addedNodes[i];
//         if (node.classList && node.classList.contains('recommendation-modal__container')) {
//           // Check if the message contains 'United Kingdom'
//           var modalMessage = node.querySelector('.recommendation-modal__message--bold');
//           if (modalMessage && modalMessage.textContent.includes('United Kingdom')) {
//             // Create the new list item element with the link
//             var newListItem = document.createElement('li');
//             newListItem.innerHTML = 'You can shop <a style="color: #0082cd; text-decoration: underline;" href="https://RIPNDIP.UK" target="_blank">RIPNDIP.UK</a> directly to get RIPNDIP product shipped domestically in the UK. Or continue below to shop RIPNDIP.COM shipping globally via Fedex with duties and taxes paid.';

//             // Find the .recommendation-modal__benefits ul and insert the new list item as the first child
//             var benefitsList = node.querySelector('.recommendation-modal__benefits ul');
//             if (benefitsList) {
//               benefitsList.insertBefore(newListItem, benefitsList.firstChild);
//             }
//           }
//         }
//       }
//     });
//   });

//   // Configuration of the observer
//   var config = {
//     childList: true,
//     subtree: true
//   };

//   // Start observing
//   observer.observe(target, config);
// });

document.addEventListener('DOMContentLoaded', function() {
    var toggleButton = document.querySelector('.currencyselectormobilmenu #dropdownToggle-toolbar');
    if (toggleButton) {
        toggleButton.addEventListener('click', function() {
            var disclosureList = document.querySelector('.currencyselectormobilmenu .disclosure-list');
            if (disclosureList) {
                disclosureList.classList.toggle('disclosure-list--visible');
            }
        });
    }
});




function checkCartStatus() {
    fetch('https://cdn.shopify.com/s/javascripts/currencies.js')
        .then(response => response.text())
        .then(script => {
            var rates = parseCurrencyRates(script);
            return fetch('/cart.js').then(response => response.json()).then(cart => ({ cart, rates }));
            
        })
        .then(({ cart, rates }) => {
            // console.log('Fetched Cart:', cart);
            var selectedCurrencyCode = cart.currency;

            var hasFreeGiftItem = cartHasFreeGiftItem(cart); // Declaration of hasFreeGiftItem

            // Define the threshold in USD (7500 cents which is $50)
            var thresholdInUSD = 7500;

            // Convert the threshold to the selected currency using parsed rates
            var thresholdInSelectedCurrency = convertCurrency(thresholdInUSD / 100, 'USD', selectedCurrencyCode, rates) * 100;
            
            // Check if the cart's total price meets or exceeds the converted threshold
            var isCartAboveThreshold = cart.total_price >= thresholdInSelectedCurrency;

            // Convert the threshold to the selected currency using parsed rates
            var thresholdInSelectedCurrency = convertCurrency(thresholdInUSD / 100, 'USD', selectedCurrencyCode, rates) * 100;
            
            // Round the threshold down to the nearest whole number
            var roundedThreshold = Math.floor(thresholdInSelectedCurrency / 100);

            // Update the .giftthresholdprice element with the rounded threshold and a dollar sign
            var thresholdElement = document.querySelector('.giftthresholdprice');
            if (thresholdElement) {
                thresholdElement.textContent = '$' + roundedThreshold + ' ' + selectedCurrencyCode;
            }

            // console.log(selectedCurrencyCode);
            // console.log(thresholdInSelectedCurrency);
            // console.log(isCartAboveThreshold);
            // console.log("Cart Total Price (cents):", cart.total_price);


            // Existing logic for handling free gifts and cart status
            if (isCartAboveThreshold && hasFreeGiftItem) {
                 // console.log('above threshold with gift');
                 $('.cartupsell-drawer').addClass('giftcontainer-hide');
                 $('.giftadded').removeClass('hide');
                 $('.choosefree').addClass('hide');
            } else if (isCartAboveThreshold && !hasFreeGiftItem) {
              //  console.log('above threshold WITHOUT gift');
                $('.cartupsell-drawer').removeClass('giftcontainer-hide');
                $('.giftadded').addClass('hide');
                $('.choosefree').removeClass('hide');
                $('.spendfree').addClass('hide');
                $('.giftcontainer').addClass('giftactive');
                $('.giftcontainer').removeClass('giftdisabled');
                $('.upsell_product').addClass('border-gradient-green');
                $('.upsell_product').removeClass('border-gradient-purple');
                $('.giftbtn').removeClass('hide');
                $('.lockicon').addClass('hide');   
                setTimeout(function() {
                  $('.product_upsell_slider').flickity({
                    draggable: true,
                    pageDots: false,
                    prevNextButtons: false
                  });
                }, 200);
                
                // Resize Flickity with a 200ms delay
                setTimeout(function() {
                  $('.product_upsell_slider').flickity('resize');
                }, 200);


            } else if (!isCartAboveThreshold && hasFreeGiftItem) {
                 //console.log('below threshold with gift');
                $('.giftadded').addClass('hide');
            } else {
               // console.log('below threshold WITHOUT gift');
                $('.giftadded').addClass('hide');
                $('.cartupsell-drawer').removeClass('giftcontainer-hide');
                $('.giftcontainer').addClass('giftdisabled');
                $('.giftcontainer').removeClass('giftactive');
                $('.choosefree').addClass('hide');
                $('.spendfree').removeClass('hide');
                $('.upsell_product').addClass('border-gradient-purple');
                $('.upsell_product').removeClass('border-gradient-green');
                $('.giftbtn').addClass('hide');
                $('.lockicon').removeClass('hide');
            }

            // console.log('Result:', hasFreeGiftItem, isCartAboveThreshold);
        })
        .catch(error => console.error('Error fetching cart:', error));
}

function parseCurrencyRates(script) {
    var ratesPattern = /rates:\{(.*?)\}/;
    var match = ratesPattern.exec(script);

    if (match && match[1]) {
        var ratesString = '{' + match[1].replace(/:(\.\d+)/g, ':0$1').replace(/(\w+):/g, '"$1":') + '}';
        try {
            var rates = JSON.parse(ratesString);
            return rates;
        } catch (error) {
            console.error('Error parsing rates:', error);
            return {};
        }
    } else {
        console.error('Rates object not found in the script');
        return {};
    }
}

function convertCurrency(amount, fromCurrency, toCurrency, rates) {
    return amount * rates[fromCurrency] / rates[toCurrency];
}

function cartHasFreeGiftItem(cart) {
    // Check if cart is valid and has items
    if (!cart || !cart.items) {
        console.log('Invalid cart data');
        return false;
    }

    for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        // Check if the item has discounts and iterate over them
        if (item.discounts && item.discounts.length > 0) {
            for (var j = 0; j < item.discounts.length; j++) {
                var discount = item.discounts[j];
                if (discount.title && discount.title === "FREE GIFT!") {
                    //console.log('Free gift found in item discounts');
                    return true;
                }
            }
        }
    }

    // console.log('No free gift found');
    return false;
}


document.addEventListener('cart:updated', function(evt) {
  // console.log('Cart updated event triggered');
  checkCartStatus();
});

document.addEventListener('ajaxProduct:added', function(evt) {
  // console.log('Cart updated event triggered');
  checkCartStatus();
});

document.addEventListener('page:loaded', function() {
  // console.log('Page Loaded event triggered');
  checkCartStatus();
});


function setupCartDrawerListener() {
    // Select the node that will be observed for mutations
    const targetNode = document.querySelector('#CartDrawer');

    // Options for the observer (which mutations to observe)
    const config = { attributes: true, attributeFilter: ['class'] };

    // Callback function to execute when mutations are observed
    const callback = function(mutationsList, observer) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const classList = targetNode.classList;
                if (classList.contains('drawer--is-open')) {
                    // Run the Flickity resize function on .product_upsell_slider
                    $('.product_upsell_slider').flickity('resize');
                }
            }
        }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
}

// Call this function when your page is ready
setupCartDrawerListener();


document.addEventListener('DOMContentLoaded', function() {
    var inStockCheckbox = document.querySelector('input[name="filter.v.availability"]');
    if (inStockCheckbox) {
        inStockCheckbox.checked = true;
    }
});

// document.addEventListener('keydown', function(event) {
//     if (event.key === 'f') {
//         var elements = document.getElementsByClassName('site-nav__link site-nav__link--icon js-search-header');
//         if (elements.length > 0) {
//             elements[0].click(); 
//         }
//     }
// });

document.addEventListener('click', function(event) {
    var searchForm = document.querySelector('.site-header__search-form');
    var searchContainer = document.querySelector('.site-header__search-container');

    if (!searchForm.contains(event.target)) {
        searchContainer.classList.remove('is-active');
    }
});

document.addEventListener('DOMContentLoaded', function () {
   $('.product_upsell_slider').flickity({
      draggable: true,
      pageDots: false,
      prevNextButtons: false
    });
    $('.js-drawer-open-cart').on('click', function() {
        $('.product_upsell_slider').flickity('resize');
    });
    $('.js-qty__adjust--minus').on('click', function() {
        $('.product_upsell_slider').flickity('resize');
    });
    $('.js-qty__adjust--plus').on('click', function() {
        $('.product_upsell_slider').flickity('resize');
    });

    checkCartStatus();
});

document.addEventListener('page:loaded', function() {
  //$('.product_upsell_slider').flickity('resize');
  checkCartStatus();
});

document.addEventListener('cart:updated', function() {
  //console.log('cartupdated test');
  $('.product_upsell_slider').flickity({
      draggable: true,
      pageDots: false,
      prevNextButtons: false
    });
  $('.product_upsell_slider').flickity('resize');
  checkCartStatus();
});

document.addEventListener('ajaxProduct:added', function() {
  $('.product_upsell_slider').flickity('resize');
});
document.addEventListener('ajaxProduct:removed', function() {
  $('.product_upsell_slider').flickity('resize');
});

function triggerFlickityResize() {
  var $slider = $('.product_upsell_slider');
  if ($slider.length) {
      var flkty = $slider.data('flickity');
      if (flkty) {
          flkty.resize();
      }
  }
}
$(document).on('click', '[data-drawer-open]', function() {
  var drawerId = $(this).attr('data-drawer-open');
  if (drawerId === '#CartDrawer') {      
      setTimeout(triggerFlickityResize, 500);
  }
});

triggerFlickityResize();


document.addEventListener('DOMContentLoaded', function () {
    
    const menu = document.getElementById('Footer-footer-1');
    
    if (menu) {
        
        const privacyChoiceItem = Array.from(menu.getElementsByTagName('li')).find(li => li.textContent.trim() === "Your Privacy Choices");
        
        if (privacyChoiceItem) {
         
            const svgImage = document.createElement('img');
            svgImage.src = "{{ 'privacyoptions.svg' | asset_url }}";
            svgImage.alt = "Privacy Options";

          
            privacyChoiceItem.insertAdjacentElement('afterend', svgImage);
        }
    }
});


document.addEventListener('DOMContentLoaded', function () {
    function handleOptionClick(event) {
        const clickedOption = event.target.closest('.bundly__product_option_value');
        if (!clickedOption) return;

        document.querySelectorAll('.bundly__product_option_value').forEach(opt => opt.classList.remove('selected'));
        clickedOption.classList.add('selected');
    }

    function checkAndDisableOptions() {
        document.querySelectorAll('.bundly__product_option_value').forEach(option => {
            const input = option.querySelector('input');
            if (input && input.classList.contains('bundly__variant_radio_disabled')) {
                option.classList.add('disabled');
            } else {
                option.classList.remove('disabled');
            }
        });
    }

    function reinitializeListeners() {
        // Reapply click events to dynamically added or updated elements
        document.querySelectorAll('.bundly__product_option_value').forEach(option => {
            option.removeEventListener('click', handleOptionClick); // Remove existing listener if already applied
            option.addEventListener('click', handleOptionClick);
        });
    }

    const observer = new MutationObserver(() => {
        reinitializeListeners(); // Reinitialize listeners when the DOM changes
        checkAndDisableOptions(); // Recheck disable logic
    });

    observer.observe(document.body, { childList: true, subtree: true }); // Observe DOM changes

    // Initial setup
    reinitializeListeners();
    checkAndDisableOptions();
});


document.addEventListener("DOMContentLoaded", function () {
    const observer = new MutationObserver(function () {
        const elements = document.querySelectorAll('p');
        elements.forEach(function (element) {
            const link = element.querySelector('a[href*="salepify"]');
            if (link && element.textContent.includes("Powered by")) {
                element.remove();
            }
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
});





document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.getElementById("countrySearch-toolbar");
  const countryListContainer = document.getElementById("countrysearch");

  if (!countryListContainer || !searchInput) {
    console.error("Error: Required elements not found.");
    return;
  }

  // Original list of country items
  const countryListItems = Array.from(
    countryListContainer.querySelectorAll(".disclosure-list__item")
  );

    // Synonyms for countries (add more as needed)
    const synonyms={
"Afghanistan":["AF","AFG","Islamic Republic of Afghanistan","AFN","Afghan Afghani"],
"Albania":["AL","ALB","Republic of Albania","ALL","Albanian Lek"],
"Algeria":["DZ","DZA","People's Democratic Republic of Algeria","DZD","Algerian Dinar"],
"Andorra":["AD","AND","Principality of Andorra","EUR","Euro"],
"Angola":["AO","AGO","Republic of Angola","AOA","Angolan Kwanza"],
"Antigua and Barbuda":["AG","ATG","State of Antigua and Barbuda","XCD","Eastern Caribbean Dollar"],
"Argentina":["AR","ARG","Argentine Republic","ARS","Argentine Peso"],
"Armenia":["AM","ARM","Republic of Armenia","AMD","Armenian Dram"],
"Australia":["AU","AUS","Commonwealth of Australia","AUD","Australian Dollar"],
"Austria":["AT","AUT","Republic of Austria","EUR","Euro"],
"Azerbaijan":["AZ","AZE","Republic of Azerbaijan","AZN","Azerbaijani Manat"],
"Bahamas":["BS","BHS","Commonwealth of the Bahamas","BSD","Bahamian Dollar"],
"Bahrain":["BH","BHR","Kingdom of Bahrain","BHD","Bahraini Dinar"],
"Bangladesh":["BD","BGD","People's Republic of Bangladesh","BDT","Bangladeshi Taka"],
"Barbados":["BB","BRB","Barbados","BBD","Barbadian Dollar"],
"Belarus":["BY","BLR","Republic of Belarus","BYN","Belarusian Ruble"],
"Belgium":["BE","BEL","Kingdom of Belgium","EUR","Euro"],
"Belize":["BZ","BLZ","Belize","BZD","Belize Dollar"],
"Benin":["BJ","BEN","Republic of Benin","XOF","West African CFA Franc"],
"Bhutan":["BT","BTN","Kingdom of Bhutan","BTN","Bhutanese Ngultrum","INR","Indian Rupee"],
"Bolivia":["BO","BOL","Plurinational State of Bolivia","BOB","Bolivian Boliviano"],
"Bosnia and Herzegovina":["BA","BIH","Bosnia & Herzegovina","BAM","Bosnia and Herzegovina Convertible Mark"],
"Botswana":["BW","BWA","Republic of Botswana","BWP","Botswana Pula"],
"Brazil":["BR","BRA","Federative Republic of Brazil","BRL","Brazilian Real"],
"Brunei Darussalam":["BN","BRN","Nation of Brunei, the Abode of Peace","BND","Brunei Dollar"],
"Bulgaria":["BG","BGR","Republic of Bulgaria","BGN","Bulgarian Lev"],
"Burkina Faso":["BF","BFA","Burkina Faso","XOF","West African CFA Franc"],
"Burundi":["BI","BDI","Republic of Burundi","BIF","Burundian Franc"],
"Côte d'Ivoire":["CI","CIV","Republic of Côte d'Ivoire","XOF","West African CFA Franc"],
"Cabo Verde":["CV","CPV","Republic of Cabo Verde","CVE","Cape Verdean Escudo"],
"Cambodia":["KH","KHM","Kingdom of Cambodia","KHR","Cambodian Riel"],
"Cameroon":["CM","CMR","Republic of Cameroon","XAF","Central African CFA Franc"],
"Canada":["CA","CAN","Dominion of Canada","CAD","Canadian Dollar"],
"Central African Republic":["CF","CAF","Central African Republic","XAF","Central African CFA Franc"],
"Chad":["TD","TCD","Republic of Chad","XAF","Central African CFA Franc"],
"Chile":["CL","CHL","Republic of Chile","CLP","Chilean Peso"],
"China":["CN","CHN","People's Republic of China","CNY","Chinese Yuan"],
"Colombia":["CO","COL","Republic of Colombia","COP","Colombian Peso"],
"Comoros":["KM","COM","Union of the Comoros","KMF","Comorian Franc"],
"Congo (Republic)":["CG","COG","Republic of the Congo","XAF","Central African CFA Franc"],
"Congo (Democratic Republic)":["CD","COD","Democratic Republic of the Congo","CDF","Congolese Franc"],
"Costa Rica":["CR","CRI","Republic of Costa Rica","CRC","Costa Rican Colón"],
"Croatia":["HR","HRV","Republic of Croatia","EUR","Euro"],
"Cuba":["CU","CUB","Republic of Cuba","CUP","Cuban Peso"],
"Cyprus":["CY","CYP","Republic of Cyprus","EUR","Euro"],
"Czech Republic (Czechia)":["CZ","CZE","Czechia","CZK","Czech Koruna"],
"Denmark":["DK","DNK","Kingdom of Denmark","DKK","Danish Krone"],
"Djibouti":["DJ","DJI","Republic of Djibouti","DJF","Djiboutian Franc"],
"Dominica":["DM","DMA","Commonwealth of Dominica","XCD","Eastern Caribbean Dollar"],
"Dominican Republic":["DO","DOM","Dominican Republic","DOP","Dominican Peso"],
"Ecuador":["EC","ECU","Republic of Ecuador","USD","US Dollar"],
"Egypt":["EG","EGY","Arab Republic of Egypt","EGP","Egyptian Pound"],
"El Salvador":["SV","SLV","Republic of El Salvador","USD","US Dollar","BTC","Bitcoin"],
"Equatorial Guinea":["GQ","GNQ","Republic of Equatorial Guinea","XAF","Central African CFA Franc"],
"Eritrea":["ER","ERI","State of Eritrea","ERN","Eritrean Nakfa"],
"Estonia":["EE","EST","Republic of Estonia","EUR","Euro"],
"Eswatini":["SZ","SWZ","Kingdom of Eswatini","SZL","Swazi Lilangeni"],
"Ethiopia":["ET","ETH","Federal Democratic Republic of Ethiopia","ETB","Ethiopian Birr"],
"Fiji":["FJ","FJI","Republic of Fiji","FJD","Fijian Dollar"],
"Finland":["FI","FIN","Republic of Finland","EUR","Euro"],
"France":["FR","FRA","French Republic","EUR","Euro"],
"Gabon":["GA","GAB","Gabonese Republic","XAF","Central African CFA Franc"],
"Gambia":["GM","GMB","Republic of The Gambia","GMD","Gambian Dalasi"],
"Georgia":["GE","GEO","Georgia","GEL","Georgian Lari"],
"Germany":["DE","DEU","Federal Republic of Germany","EUR","Euro"],
"Ghana":["GH","GHA","Republic of Ghana","GHS","Ghanaian Cedi"],
"Greece":["GR","GRC","Hellenic Republic","EUR","Euro"],
"Grenada":["GD","GRD","Grenada","XCD","Eastern Caribbean Dollar"],
"Guatemala":["GT","GTM","Republic of Guatemala","GTQ","Guatemalan Quetzal"],
"Guinea":["GN","GIN","Republic of Guinea","GNF","Guinean Franc"],
"Guinea-Bissau":["GW","GNB","Republic of Guinea-Bissau","XOF","West African CFA Franc"],
"Guyana":["GY","GUY","Co-operative Republic of Guyana","GYD","Guyanese Dollar"],
"Haiti":["HT","HTI","Republic of Haiti","HTG","Haitian Gourde"],
"Honduras":["HN","HND","Republic of Honduras","HNL","Honduran Lempira"],
"Hungary":["HU","HUN","Hungary","HUF","Hungarian Forint"],
"Iceland":["IS","ISL","Republic of Iceland","ISK","Icelandic Króna"],
"India":["IN","IND","Republic of India","INR","Indian Rupee"],
"Indonesia":["ID","IDN","Republic of Indonesia","IDR","Indonesian Rupiah"],
"Iran":["IR","IRN","Islamic Republic of Iran","IRR","Iranian Rial"],
"Iraq":["IQ","IRQ","Republic of Iraq","IQD","Iraqi Dinar"],
"Ireland":["IE","IRL","Republic of Ireland","EUR","Euro"],
"Israel":["IL","ISR","State of Israel","ILS","Israeli New Shekel"],
"Italy":["IT","ITA","Italian Republic","EUR","Euro"],
"Jamaica":["JM","JAM","Jamaica","JMD","Jamaican Dollar"],
"Japan":["JP","JPN","State of Japan","JPY","Japanese Yen"],
"Jordan":["JO","JOR","Hashemite Kingdom of Jordan","JOD","Jordanian Dinar"],
"Kazakhstan":["KZ","KAZ","Republic of Kazakhstan","KZT","Kazakhstani Tenge"],
"Kenya":["KE","KEN","Republic of Kenya","KES","Kenyan Shilling"],
"Kiribati":["KI","KIR","Republic of Kiribati","AUD","Australian Dollar"],
"Korea (Democratic People's Republic)":["KP","PRK","DPRK","Democratic People's Republic of Korea","KPW","North Korean Won"],
"Korea (Republic of)":["KR","KOR","Republic of Korea","KRW","South Korean Won"],
"Kuwait":["KW","KWT","State of Kuwait","KWD","Kuwaiti Dinar"],
"Kyrgyzstan":["KG","KGZ","Kyrgyz Republic","KGS","Kyrgyzstani Som"],
"Lao People's Democratic Republic":["LA","LAO","Laos","LAK","Lao Kip"],
"Latvia":["LV","LVA","Republic of Latvia","EUR","Euro"],
"Lebanon":["LB","LBN","Lebanese Republic","LBP","Lebanese Pound"],
"Lesotho":["LS","LSO","Kingdom of Lesotho","LSL","Lesotho Loti","ZAR","South African Rand"],
"Liberia":["LR","LBR","Republic of Liberia","LRD","Liberian Dollar"],
"Libya":["LY","LBY","State of Libya","LYD","Libyan Dinar"],
"Liechtenstein":["LI","LIE","Principality of Liechtenstein","CHF","Swiss Franc"],
"Lithuania":["LT","LTU","Republic of Lithuania","EUR","Euro"],
"Luxembourg":["LU","LUX","Grand Duchy of Luxembourg","EUR","Euro"],
"Madagascar":["MG","MDG","Republic of Madagascar","MGA","Malagasy Ariary"],
"Malawi":["MW","MWI","Republic of Malawi","MWK","Malawian Kwacha"],
"Malaysia":["MY","MYS","Malaysia","MYR","Malaysian Ringgit"],
"Maldives":["MV","MDV","Republic of Maldives","MVR","Maldivian Rufiyaa"],
"Mali":["ML","MLI","Republic of Mali","XOF","West African CFA Franc"],
"Malta":["MT","MLT","Republic of Malta","EUR","Euro"],
"Marshall Islands":["MH","MHL","Republic of the Marshall Islands","USD","US Dollar"],
"Mauritania":["MR","MRT","Islamic Republic of Mauritania","MRU","Mauritanian Ouguiya"],
"Mauritius":["MU","MUS","Republic of Mauritius","MUR","Mauritian Rupee"],
"Mexico":["MX","MEX","United Mexican States","MXN","Mexican Peso"],
"Micronesia (Federated States of)":["FM","FSM","Federated States of Micronesia","USD","US Dollar"],
"Moldova":["MD","MDA","Republic of Moldova","MDL","Moldovan Leu"],
"Monaco":["MC","MCO","Principality of Monaco","EUR","Euro"],
"Mongolia":["MN","MNG","Mongolia","MNT","Mongolian Tögrög"],
"Montenegro":["ME","MNE","Montenegro","EUR","Euro"],
"Morocco":["MA","MAR","Kingdom of Morocco","MAD","Moroccan Dirham"],
"Mozambique":["MZ","MOZ","Republic of Mozambique","MZN","Mozambican Metical"],
"Myanmar":["MM","MMR","Republic of the Union of Myanmar","MMK","Burmese Kyat"],
"Namibia":["NA","NAM","Republic of Namibia","NAD","Namibian Dollar","ZAR","South African Rand"],
"Nauru":["NR","NRU","Republic of Nauru","AUD","Australian Dollar"],
"Nepal":["NP","NPL","Federal Democratic Republic of Nepal","NPR","Nepalese Rupee"],
"Netherlands":["NL","NLD","Kingdom of the Netherlands","EUR","Euro","Holland"],
"New Zealand":["NZ","NZL","Aotearoa","NZD","New Zealand Dollar"],
"Nicaragua":["NI","NIC","Republic of Nicaragua","NIO","Nicaraguan Córdoba"],
"Niger":["NE","NER","Republic of the Niger","XOF","West African CFA Franc"],
"Nigeria":["NG","NGA","Federal Republic of Nigeria","NGN","Nigerian Naira"],
"North Macedonia":["MK","MKD","Republic of North Macedonia","MKD","Macedonian Denar"],
"Norway":["NO","NOR","Kingdom of Norway","NOK","Norwegian Krone"],
"Oman":["OM","OMN","Sultanate of Oman","OMR","Omani Rial"],
"Pakistan":["PK","PAK","Islamic Republic of Pakistan","PKR","Pakistani Rupee"],
"Palau":["PW","PLW","Republic of Palau","USD","US Dollar"],
"Panama":["PA","PAN","Republic of Panama","PAB","Panamanian Balboa","USD","US Dollar"],
"Papua New Guinea":["PG","PNG","Independent State of Papua New Guinea","PGK","Papua New Guinean Kina"],
"Paraguay":["PY","PRY","Republic of Paraguay","PYG","Paraguayan Guaraní"],
"Peru":["PE","PER","Republic of Peru","PEN","Peruvian Sol"],
"Philippines":["PH","PHL","Republic of the Philippines","PHP","Philippine Peso"],
"Poland":["PL","POL","Republic of Poland","PLN","Polish Złoty"],
"Portugal":["PT","PRT","Portuguese Republic","EUR","Euro"],
"Qatar":["QA","QAT","State of Qatar","QAR","Qatari Riyal"],
"Romania":["RO","ROU","Romania","RON","Romanian Leu"],
"Russia":["RU","RUS","Russian Federation","RUB","Russian Ruble"],
"Rwanda":["RW","RWA","Republic of Rwanda","RWF","Rwandan Franc"],
"Saint Kitts and Nevis":["KN","KNA","Federation of Saint Kitts and Nevis","XCD","Eastern Caribbean Dollar"],
"Saint Lucia":["LC","LCA","Saint Lucia","XCD","Eastern Caribbean Dollar"],
"Saint Vincent and the Grenadines":["VC","VCT","Saint Vincent and the Grenadines","XCD","Eastern Caribbean Dollar"],
"Samoa":["WS","WSM","Independent State of Samoa","WST","Samoan Tala"],
"San Marino":["SM","SMR","Republic of San Marino","EUR","Euro"],
"Sao Tome and Principe":["ST","STP","Democratic Republic of Sao Tome and Principe","STN","São Tomé and Príncipe Dobra"],
"Saudi Arabia":["SA","SAU","Kingdom of Saudi Arabia","SAR","Saudi Riyal"],
"Senegal":["SN","SEN","Republic of Senegal","XOF","West African CFA Franc"],
"Serbia":["RS","SRB","Republic of Serbia","RSD","Serbian Dinar"],
"Seychelles":["SC","SYC","Republic of Seychelles","SCR","Seychellois Rupee"],
"Sierra Leone":["SL","SLE","Republic of Sierra Leone","SLL","Sierra Leonean Leone"],
"Singapore":["SG","SGP","Republic of Singapore","SGD","Singapore Dollar"],
"Slovakia":["SK","SVK","Slovak Republic","EUR","Euro"],
"Slovenia":["SI","SVN","Republic of Slovenia","EUR","Euro"],
"Solomon Islands":["SB","SLB","Solomon Islands","SBD","Solomon Islands Dollar"],
"Somalia":["SO","SOM","Federal Republic of Somalia","SOS","Somali Shilling"],
"South Africa":["ZA","ZAF","Republic of South Africa","ZAR","South African Rand"],
"South Sudan":["SS","SSD","Republic of South Sudan","SSP","South Sudanese Pound"],
"Spain":["ES","ESP","Kingdom of Spain","EUR","Euro"],
"Sri Lanka":["LK","LKA","Democratic Socialist Republic of Sri Lanka","LKR","Sri Lankan Rupee"],
"Sudan":["SD","SDN","Republic of the Sudan","SDG","Sudanese Pound"],
"Suriname":["SR","SUR","Republic of Suriname","SRD","Surinamese Dollar"],
"Sweden":["SE","SWE","Kingdom of Sweden","SEK","Swedish Krona"],
"Switzerland":["CH","CHE","Swiss Confederation","CHF","Swiss Franc"],
"Syria":["SY","SYR","Syrian Arab Republic","SYP","Syrian Pound"],
"Tajikistan":["TJ","TJK","Republic of Tajikistan","TJS","Tajikistani Somoni"],
"Tanzania":["TZ","TZA","United Republic of Tanzania","TZS","Tanzanian Shilling"],
"Thailand":["TH","THA","Kingdom of Thailand","THB","Thai Baht"],
"Timor-Leste":["TL","TLS","Democratic Republic of Timor-Leste","USD","US Dollar"],
"Togo":["TG","TGO","Togolese Republic","XOF","West African CFA Franc"],
"Tonga":["TO","TON","Kingdom of Tonga","TOP","Tongan Paʻanga"],
"Trinidad and Tobago":["TT","TTO","Republic of Trinidad and Tobago","TTD","Trinidad and Tobago Dollar"],
"Tunisia":["TN","TUN","Republic of Tunisia","TND","Tunisian Dinar"],
"Turkey":["TR","TUR","Republic of Türkiye","TRY","Turkish Lira"],
"Turkmenistan":["TM","TKM","Turkmenistan","TMT","Turkmenistan Manat"],
"Tuvalu":["TV","TUV","Tuvalu","AUD","Australian Dollar"],
"Uganda":["UG","UGA","Republic of Uganda","UGX","Ugandan Shilling"],
"Ukraine":["UA","UKR","Ukraine","UAH","Ukrainian Hryvnia"],
"United Arab Emirates":["AE","ARE","UAE","دولة الإمارات العربية المتحدة","AED","UAE Dirham"],
"United Kingdom":["GB","GBR","UK","Britain","England","British Pound","GBP"],
"United States":["US","USA","U.S.A.","America","United States of America","USD","U.S. Dollar"],
"Uruguay":["UY","URY","Oriental Republic of Uruguay","UYU","Uruguayan Peso"],
"Uzbekistan":["UZ","UZB","Republic of Uzbekistan","UZS","Uzbekistan Som"],
"Vanuatu":["VU","VUT","Republic of Vanuatu","VUV","Vanuatu Vatu"],
"Venezuela":["VE","VEN","Bolivarian Republic of Venezuela","VES","Venezuelan Bolívar"],
"Vietnam":["VN","VNM","Socialist Republic of Vietnam","VND","Vietnamese đồng"],
"Yemen":["YE","YEM","Republic of Yemen","YER","Yemeni Rial"],
"Zambia":["ZM","ZMB","Republic of Zambia","ZMW","Zambian Kwacha"],
"Zimbabwe":["ZW","ZWE","Republic of Zimbabwe","ZWL","Zimbabwean Dollar"]
};

    
// Function to check search query against country names and synonyms
  const matchWithSynonyms = (query, label) => {
    if (label.toLowerCase().includes(query)) return true;
    for (const [country, syns] of Object.entries(synonyms)) {
      if (label.toLowerCase().includes(country.toLowerCase())) {
        if (syns.some((syn) => syn.toLowerCase().includes(query))) {
          return true;
        }
      }
    }
    return false;
  };

  // Search input event listener
  searchInput.addEventListener("input", function () {
    const query = searchInput.value.toLowerCase().trim();
    let visibleItemsCount = 0;

    countryListItems.forEach((item) => {
      const label = item.querySelector(".disclosure-list__label").textContent.toLowerCase();
      if (!query || matchWithSynonyms(query, label)) {
        item.style.display = ""; // Show matching item
        visibleItemsCount++;
      } else {
        item.style.display = "none"; // Hide non-matching item
      }
    });

    // Handle "No Results Found" Message
    let noResultsMessage = document.querySelector(".no-results-message");
    if (visibleItemsCount === 0) {
      if (!noResultsMessage) {
        noResultsMessage = document.createElement("li");
        noResultsMessage.className = "disclosure-list__item no-results-message";
        noResultsMessage.textContent = "No results found";
        countryListContainer.appendChild(noResultsMessage);
      }
    } else {
      if (noResultsMessage) noResultsMessage.remove();
    }
  });

  // Prevent right-click menu interference
  document.querySelector('.disclosure-list').addEventListener('contextmenu', function (event) {
    event.stopPropagation();
  });

  // Close dropdown if clicking outside
  document.addEventListener('click', function (event) {
    const drawer = document.querySelector('.disclosure-list');
    if (drawer.classList.contains('disclosure-list--visible')) {
      if (!drawer.contains(event.target) && event.button === 0) {
        // drawer.classList.remove('disclosure-list--visible');
      }
    }
  });
});



function hidePoweredByText() {
    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType === 1) { // Ensure it's an element node
                    const paragraphs = node.querySelectorAll ? node.querySelectorAll('p') : [];
                    paragraphs.forEach(p => {
                        if (p.textContent.includes('Powered by') && p.textContent.includes('Salepify App')) {
                            p.style.display = 'none';
                        }
                    });
                }
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Run once in case the element is already present
    document.querySelectorAll('p').forEach(p => {
        if (p.textContent.includes('Powered by') && p.textContent.includes('Salepify App')) {
            p.style.display = 'none';
        }
    });
}

// Run after the page loads
document.addEventListener("DOMContentLoaded", hidePoweredByText);
































